import { useState } from 'react'
import { C, R, F } from '../../lib/designTokens'
import * as pk from '../../services/productKnowledgeService'

const KIND_OPTIONS = [
  { value: 'missing', label: 'Missing / مفقود' },
  { value: 'unclear', label: 'Unclear / غير واضح' },
  { value: 'incorrect', label: 'Incorrect / غير صحيح' },
  { value: 'outdated', label: 'Outdated / قديم' },
  { value: 'ui_mismatch', label: "Doesn't match the app / لا يطابق التطبيق" },
  { value: 'other', label: 'Other / أخرى' },
]

// unit: the object returned by pk.getUnit() -- {id, key, kind, audience, row_version}.
// Report a Gap is only offered once this authoritative identity is loaded;
// the ID/kind/row_version are never guessed on the frontend.
export default function ReportGapButton({ unit }) {
  const [open, setOpen] = useState(false)
  const [kind, setKind] = useState('missing')
  const [description, setDescription] = useState('')
  const [status, setStatus] = useState('idle') // idle | submitting | done | error
  const [errMsg, setErrMsg] = useState(null)

  if (!unit) return null

  const descLen = description.trim().length
  const descValid = descLen >= 10 && descLen <= 1000

  async function submit() {
    if (!descValid) return
    setStatus('submitting')
    setErrMsg(null)
    try {
      await pk.reportGap({
        unit,
        lang: 'en',
        kind,
        description: description.trim(),
      })
      setStatus('done')
    } catch (e) {
      setStatus('error')
      setErrMsg(e?.message?.includes('RATE_LIMITED')
        ? 'Too many reports in the last hour. Please try again later. / عدد كبير من البلاغات في الساعة الأخيرة، حاول لاحقاً.'
        : 'Could not submit. / تعذّر الإرسال.')
    }
  }

  if (!open) {
    return (
      <button onClick={() => setOpen(true)}
        style={{ fontSize: F.caption, color: C.sub, background: 'none', border: 'none', cursor: 'pointer', textDecoration: 'underline', padding: 0 }}>
        Report a gap in this content / الإبلاغ عن نقص في هذا المحتوى
      </button>
    )
  }

  return (
    <div style={{ marginTop: 10, padding: 14, borderRadius: R.card, border: `1px solid ${C.border}`, background: C.surfaceAlt, maxWidth: 480 }}>
      {status === 'done' ? (
        <p style={{ fontSize: F.body, color: C.green, margin: 0 }}>Thank you -- your report was received. / شكراً، تم استلام بلاغك.</p>
      ) : (
        <>
          <div style={{ fontSize: F.title, fontWeight: 700, color: C.ink, marginBottom: 8 }}>Report a gap / الإبلاغ عن نقص</div>
          <select value={kind} onChange={e => setKind(e.target.value)}
            style={{ width: '100%', fontSize: F.body, padding: '7px 10px', borderRadius: R.input, border: `1px solid ${C.border}`, marginBottom: 8, fontFamily: 'inherit' }}>
            {KIND_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
          </select>
          <textarea
            value={description}
            onChange={e => setDescription(e.target.value)}
            placeholder="Describe what's missing or incorrect (10-1000 characters). / صف ما هو مفقود أو غير صحيح."
            rows={3}
            style={{ width: '100%', fontSize: F.body, padding: '8px 10px', borderRadius: R.input, border: `1px solid ${C.border}`, fontFamily: 'inherit', resize: 'vertical' }}
          />
          <div style={{ fontSize: 10, color: descValid ? C.sub : C.red, marginTop: 3, marginBottom: 8 }}>
            {descLen}/1000 {descLen < 10 ? '(min. 10 characters)' : ''}
          </div>
          {errMsg && <div style={{ fontSize: F.caption, color: C.red, marginBottom: 8 }}>{errMsg}</div>}
          <div style={{ display: 'flex', gap: 8 }}>
            <button onClick={submit} disabled={!descValid || status === 'submitting'}
              style={{
                fontSize: F.caption, fontWeight: 600, padding: '7px 14px', borderRadius: R.btn, border: 'none',
                background: descValid ? C.blue : C.border2, color: '#fff',
                cursor: descValid ? 'pointer' : 'not-allowed',
              }}>
              {status === 'submitting' ? 'Sending… / جارٍ الإرسال…' : 'Submit / إرسال'}
            </button>
            <button onClick={() => setOpen(false)}
              style={{ fontSize: F.caption, padding: '7px 14px', borderRadius: R.btn, border: `1px solid ${C.border}`, background: C.surface, cursor: 'pointer' }}>
              Cancel / إلغاء
            </button>
          </div>
        </>
      )}
    </div>
  )
}
